export function getComponentDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export function getHocDisplayName(name, WrappedComponent) {
  return `${name}(${getComponentDisplayName(WrappedComponent)})`;
}
